import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbeb1382"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid product-overview-bg" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Filters", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Filters", -1))
const _hoisted_7 = { class: "header-left justify-content-between justify-content-lg-start flex-grow-1 flex-lg-grow-0" }
const _hoisted_8 = { class: "header-right flex-grow-1 flex-lg-grow-0" }
const _hoisted_9 = {
  key: 0,
  class: "p-input-icon-left p-input-icon-right header-search"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpertFilters = _resolveComponent("ExpertFilters")!
  const _component_ProductFilters = _resolveComponent("ProductFilters")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _component_SlideSidebar = _resolveComponent("SlideSidebar")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataViewLayoutOptions = _resolveComponent("DataViewLayoutOptions")!
  const _component_Message = _resolveComponent("Message")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_ScrollTop = _resolveComponent("ScrollTop")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {}, undefined, true),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_SlideSidebar, {
          modelValue: _ctx.showFilters,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showFilters) = $event)),
          onClose: _cache[1] || (_cache[1] = () => (_ctx.showFilters = _ctx.$event))
        }, {
          header: _withCtx(() => [
            _hoisted_5
          ]),
          content: _withCtx(() => [
            _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"70vh","overflow-x":"hidden"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ProductFilters, { onFiltersChanged: _ctx.onFilterChange }, {
                  default: _withCtx(() => [
                    (_ctx.isExpertProduct)
                      ? (_openBlock(), _createBlock(_component_ExpertFilters, {
                          key: 0,
                          onOnExpertFilterChange: _ctx.onFilterChange
                        }, null, 8, ["onOnExpertFilterChange"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onFiltersChanged"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]), [
          [_vShow, _ctx.filterStore.hasOptionFilters && !_ctx.isSmallScreen]
        ]),
        (_ctx.filterStore.hasOptionFilters && _ctx.isSmallScreen)
          ? (_openBlock(), _createBlock(_component_Sidebar, {
              key: 0,
              visible: _ctx.showFilters,
              "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showFilters) = $event)),
              class: "surface-200"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _hoisted_6,
                  _createVNode(_component_ProductFilters, { onFiltersChanged: _ctx.onFilterChange }, {
                    default: _withCtx(() => [
                      (_ctx.isExpertProduct)
                        ? (_openBlock(), _createBlock(_component_ExpertFilters, {
                            key: 0,
                            onOnExpertFilterChange: _ctx.onFilterChange
                          }, null, 8, ["onOnExpertFilterChange"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["onFiltersChanged"])
                ])
              ]),
              _: 1
            }, 8, ["visible"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataView, {
          class: "w-100 data-view-list",
          layout: _ctx.isSmallScreen ? 'grid' : _ctx.viewLayout,
          value: _ctx.overviewItems
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.filterStore.hasOptionFilters)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    badge: _ctx.filterStore.hasActiveFilters ? _ctx.filterStore.activeFilterCount.toString() : '',
                    class: "p-button-outlined mr-1 flex-shrink-0",
                    label: _ctx.$t('common.filters'),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
                  }, null, 8, ["badge", "label"]))
                : _createCommentVNode("", true),
              (_ctx.filterStore.sortOptions.length > 0)
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 1,
                    modelValue: _ctx.filterStore.sortKey,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterStore.sortKey) = $event)),
                    "append-to": "self",
                    "option-label": "label",
                    options: _ctx.filterStore.sortOptions,
                    placeholder: _ctx.$t('product.sort_placeholder'),
                    "scroll-height": "400px",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSortChange($event)))
                  }, null, 8, ["modelValue", "options", "placeholder"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.filterStore.hasQueryFilter)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["pi pi-search", { 'text-primary': _ctx.filterStore.hasActiveQueryFilter }])
                    }, null, 2),
                    _withDirectives(_createVNode(_component_InputText, {
                      modelValue: _ctx.queryString,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.queryString) = $event)),
                      class: "mr-1",
                      placeholder: _ctx.searchPlaceholderText,
                      type: "search"
                    }, null, 8, ["modelValue", "placeholder"]), [
                      [_directive_debounce, _ctx.onSearch, "1s"]
                    ]),
                    (_ctx.queryString?.length)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "pi pi-times icon-clear",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.queryString = ''; _ctx.onSearch(_ctx.queryString);})
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isSmallScreen)
                ? (_openBlock(), _createBlock(_component_DataViewLayoutOptions, {
                    key: 1,
                    modelValue: _ctx.viewLayout,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.viewLayout) = $event)),
                    class: "ml-1",
                    onClick: _ctx.onLayoutChanged
                  }, null, 8, ["modelValue", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          empty: _withCtx(() => [
            _createVNode(_component_Message, {
              closable: false,
              severity: "warn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("product.message.noOverviewItems")), 1)
              ]),
              _: 1
            })
          ]),
          list: _withCtx((item) => [
            _renderSlot(_ctx.$slots, "list-item", {
              data: item.data
            }, undefined, true)
          ]),
          grid: _withCtx((item) => [
            _renderSlot(_ctx.$slots, "grid-item", {
              data: item.data
            }, undefined, true)
          ]),
          _: 3
        }, 8, ["layout", "value"])
      ]),
      _createVNode(_component_ScrollTop, {
        target: "parent",
        threshold: 200
      })
    ])
  ]))
}